import { render, staticRenderFns } from "./Knobs.vue?vue&type=template&id=8c007102&"
import script from "./Knobs.vue?vue&type=script&lang=ts&"
export * from "./Knobs.vue?vue&type=script&lang=ts&"
import style0 from "./Knobs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports